// client/src/components/register/RegisterPage.js
import React from 'react';
import RegisterForm from './RegisterForm';
import { useAuth } from '../../context/AuthContext'; // Import useAuth
import { Navigate } from 'react-router-dom'; // Import Navigate
import LoadingSpinner from '../common/LoadingSpinner';
import './RegisterPage.css'

function RegisterPage() {
    const { isLoggedIn, loading } = useAuth(); // Get isLoggedIn AND loading

    if (loading) {
        return <LoadingSpinner />; // Use the LoadingSpinner
    }

    if (isLoggedIn) {
        return <Navigate to="/dashboard" replace />; // Redirect
    }

    return (
        <div className="register-page">
            <RegisterForm />
        </div>
    );
}

export default RegisterPage;